import {createAction, props} from '@ngrx/store';
import {Course, CourseContent} from '../../services/course-data.service';

export const courseListRequested = createAction('[Courses] Get List');
export const courseListReceived = createAction('[Courses] Set List', props<{courses: Course[]}>());
export const courseStubListReceived = createAction('[Courses] Set Stub List', props<{courses: Course[]}>());

export const setNeedsMostRecentCourse = createAction('[Courses] Needs Most Recent');

export const setCurrentCourse = createAction('[Courses] Set Current', props<{currentCourse: string}>());
export const setCurrentLesson = createAction('[Courses] Set Current Lesson', props<{currentLesson: string}>());
export const setCurrentLessonItem = createAction('[Courses] Set Current Lesson Item', props<{itemType: string, item: CourseContent}>());
export const getCourseDetails = createAction('[Courses] Get Course Details', props<{courseSlug: string, courseCodename}>());
export const setCourseDetails = createAction('[Courses] Set Course Details', props<{course: Course}>());

export const setVideoPlay = createAction('[Video] Play Pressed', props<{
	courseId: string, contentId: string, videoId: string
}>());
export const setVideoReachedEnd = createAction('[Video] End Reached', props<{
	courseId: string, contentId: string, videoId: string
}>());
export const setVideoCompleted = createAction('[Video] Completed', props<{
	courseId: string, contentId: string, videoId: string
}>());
export const setVideoProgress = createAction('[Video] Set Progress', props<{
	courseId: string, contentId: string, videoId: string, progress: number, eventTime: number
}>());
export const setVideoProgressForce = createAction('[Video] Set Progress (Force)', props<{
	courseId: string, contentId: string, videoId: string, progress: number, eventTime: number
}>());
export const setVideoProgressList = createAction('[Video] Set Progress List', props<{
	list: {videoId: string, progress: number, modifiedDate: Date}[]
}>());

export const setVideoLastPostTime = createAction('[Video] Set Last Post Time', props<{videoId: string, postTime: number}>());

export const trash = createAction('[Courses] Ignore Action');
